/**
 * P-L1 linked-chip resolver, browser side.
 *
 * One question every desk asks — "given this record, what else is attached to
 * it?" — answered by ONE resolver so record chips, Growth home, the cockpit and
 * the meeting pack cannot drift apart
 * (major-push/lcat-intelligence/09-lifecycle-spine.md).
 *
 * Read-only. The tenant comes from the authenticated principal in ryugu, never
 * from anything this hook sends.
 */ import { DeliveryTypes } from '@mono/proto-clients';
import { useQuery } from '@tanstack/react-query';
import { deliveryClient } from '../../lib/connect/clients';
export const LifecycleNodeKind = DeliveryTypes.LifecycleNodeKind;
export const linkedNodesQueryKey = (kind, id)=>[
        'lifecycleChips',
        kind,
        id
    ];
/**
 * Resolves one record's neighbours, counts and unresolved links.
 *
 * Disabled until an id exists so a chip rail on a not-yet-loaded record does not
 * fire a request for the empty string.
 */ export function useLinkedNodes(kind, id) {
    return useQuery({
        queryKey: linkedNodesQueryKey(kind, id ?? ''),
        enabled: Boolean(id) && kind !== DeliveryTypes.LifecycleNodeKind.UNSPECIFIED,
        queryFn: async ()=>{
            const resp = await deliveryClient.getLinkedNodes({
                // companyId is intentionally omitted: ryugu takes the tenant from the
                // principal and only logs a mismatch if a caller sends one.
                kind,
                id: id ?? ''
            });
            return {
                node: resp.node,
                edges: resp.edges,
                counts: resp.counts,
                unresolved: resp.unresolved
            };
        },
        // Links change on convert/award, not on every keystroke — but a stale rail
        // after a conversion is confusing, so keep this short rather than long.
        staleTime: 30000
    });
}
